import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { setUserSession, getCompanyId, getUser, decode_token_acls } from '../../Utils/Common';
import { usePermissionContext } from "../../contexts/permission-context";
import { useNavigate } from "react-router-dom";
import Grid from '@mui/material/Grid';
import { TextField, IconButton, InputAdornment, Button, Typography, Paper, Autocomplete } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LoginHeaderLogo from '../../images/login-logo.svg';
import './login.scss';

function Login(props) {
  const { setPermissions } = usePermissionContext();
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [companyIds, setCompanyIds] = useState([]);
  const [companyId, setCompanyId] = useState();
  // const [inputValue, setInputValue] = useState('');
  const username = useFormInput('');
  const password = useFormInput('');
  const [error, setError] = useState(null);

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    getOAuth2Companies()
  }, [])

  const getOAuth2Companies = () => {

    axios.get("/api/idps/oauth2/companyIds").then((response) => {
      let data = [];
      response.data.forEach((item, key) => (
        data[key] = { label: item, id: +item.split('-')[0] }
      ))

      setCompanyIds(data)
      setCompanyId(data[0].id)
      // setInputValue(data[0].label)
    }).catch((err) => {
      console.log('err', err)
    })
  }


  const handleClickShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (value) => {
    setCompanyId(value.id)
    // setInputValue(value.label)
  }

  // handle button click of login form
  const handleLogin = () => {
    setError(null);
    setLoading(true);
    let bodyFormData = new FormData();
    bodyFormData.append('username', username.value);
    bodyFormData.append('password', btoa(password.value));
    let data = '';
    axios({ method: "post", url: '/api/login', data: bodyFormData, headers: { "Content-Type": "multipart/form-data" } })
      .then(response => {
        setLoading(false);
        // console.log('login res:', response);
        setUserSession(response.data.token, response.data.userId, response.data.companyId, response.data.environment);
        let acls = decode_token_acls(response.data.token);
        setPermissions(acls);
        navigate('main');
        data = 'Login for user: ' + username.value + '  successful.';
        logDataInServer(data, 'info');
      })
      .catch(err => {
        console.log('error in login api call:', err);
        data = 'Login for user: ' + username.value + '  failed due to : ' + err.response.data.message;
        setLoading(false);
        if (err.response.status === 401) {
          setError("Invalid username / password. Please try again.");
          navigate('/'); // was /login
        }
        else {
          setError("Something went wrong. Please try again later.");
          username.value = '';
          password.value = '';
          console.log('something else went wrong. not auth issue.');
        }
      })
  }

  const paperStyle = { padding: 20, height: 'auto', width: 330, margin: "20px auto", borderRadius: 20 };
  const btnstyle = { marginTop: '16px', height: '56px', borderRadius: '8px' };
  const footerText = `© 2021-2023, Iron Mountain Incorporated. All rights reserved. CONFIDENTIAL AND PROPRIETARY INFORMATION. The information contained herein (the 'Proprietary Information') is highly confidential and proprietary to and constitutes trade secrets of Iron Mountain. The Proprietary Information is for Iron Mountain internal use only and shall not be published, communicated, disclosed or divulged to any person, firm, corporation or other legal entity, directly or indirectly, without the prior written consent of Iron Mountain Information Management.`;

  return (
    <>
      <div className="loginBody">
        <div className="loginContainer">

          <div style={{ height: '125px', width: '100%' }}></div>
          <div className="loginCard">
            <Grid container>
              <Paper elevation={10} style={paperStyle}>
                <Grid item sx={{ width: '295px' }}>
                  <img alt="logo" src={LoginHeaderLogo} className='imgStyle' />
                </Grid>
                <Grid item sx={{ marginTop: '24px', gap: '8px' }}>
                  <div className="loginHeading">Sign In</div>
                  {error && <Typography style={{ color: 'red' }}>{error}</Typography>}
                  <Autocomplete
                    disablePortal
                    value={companyId}
                    onChange={(event, newValue) => handleChange(newValue)}
                    size="small"
                    id="company_autocomplete"
                    options={companyIds}
                    renderInput={(params) => <TextField margin="normal"  {...params} label="Company ID" />}
                  />
                  <TextField label='Username' placeholder='Enter username' fullWidth required {...username} size="small" margin="normal" />
                  <TextField label='Password' placeholder='Enter password' type={showPassword ? 'text' : 'password'} size="small" fullWidth required {...password} margin="normal"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />

                  <Button type='submit' color='primary' variant="contained" style={btnstyle} fullWidth onClick={handleLogin} disabled={loading}>{loading ? 'Loading...' : 'SIGN IN'}</Button>
                </Grid>

                <Grid align='center' sx={{ marginTop: '32px' }} fullwidth>
                  <div className="googleLoginSection">
                    <div className="signInLabel">Or sign in with</div>
                    <a href={`/api/oauth2/${companyId}/SSO/login/monitoruiapp`} style={{ textTransform: 'none', textDecoration: 'none', width: '100%' }}>
                      <div className="googleButton" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <span className='icon'></span>
                        <span className='buttonText'>Google</span>
                      </div>
                    </a>
                  </div>
                </Grid>


              </Paper>
            </Grid>
          </div>

          <footer>
            <div class="content">
              <a href="https://www.ironmountain.com/utility/legal/privacy-policy" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>Privacy Policy</a>
              <p style={{ marginTop: 0, marginBottom: 0 }}>{footerText}</p>
            </div>
          </footer>

        </div>

      </div>

    </>
  );

}

const logDataInServer = function (data, level) {
  // console.log('data for api:', data);
  axios({ method: "post", url: '/logging', data: { errorData: data, level: level, userId: getUser(), companyId: getCompanyId() } })
    .then(() => {
      console.log('Logged info in server side logs successfully');
    })
    .catch((err) => {
      console.log('Error while calling logger API: ', err);
    });
}

const useFormInput = initialValue => {
  const [value, setValue] = useState(initialValue);

  const handleChange = e => {
    setValue(e.target.value);
  }
  return {
    value,
    onChange: handleChange
  }
}

export default Login;